module.exports = __webpack_public_path__ + "static/media/Cards.fda72c2f.svg";